module.exports = __webpack_public_path__ + "static/product-e77a583b03f94a7635edc95be7cb35b0.png";